import { render, staticRenderFns } from "./CheckDataFromFileStepOne.vue?vue&type=template&id=806c4c0a&"
import script from "./CheckDataFromFileStepOne.vue?vue&type=script&lang=js&"
export * from "./CheckDataFromFileStepOne.vue?vue&type=script&lang=js&"
import style0 from "./CheckDataFromFileStepOne.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports